import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useCrmFacebookLeadFormPipeStatus = () =>
  useQuery<crmModels.IFacebookPipeStatus[]>({
    queryKey: [crmConstants.queryKeys.CRM_FACEBOOK_LEAD_FORM_PIPE_STATUS],
    queryFn: async () => {
      const res = await $api.get('/v1/crm/facebook/lead-form/pipe-status');

      return res?.data?.data;
    }
  });
